function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
import { useMemo } from "react";
var buildStyle = function(param, param1) {
    var spacing = param.spacing, end = param1.end, start = param1.start;
    return {
        'textbox-icon-container': {
            height: spacing[6],
            width: spacing[6],
            position: 'absolute',
            bottom: '9px',
            display: 'block'
        },
        'textbox-small': {
            bottom: '6px'
        },
        variant: {
            default: {},
            grid: {
                height: spacing[5],
                width: spacing[5],
                bottom: '4px'
            },
            underline: {},
            outline: {}
        },
        left: {
            default: _defineProperty({}, start.direction, spacing[5]),
            grid: _defineProperty({}, start.direction, spacing[2]),
            underline: _defineProperty({}, start.direction, spacing[5]),
            outline: _defineProperty({}, start.direction, spacing[5])
        },
        right: {
            default: _defineProperty({}, end.direction, spacing[5]),
            grid: _defineProperty({}, end.direction, spacing[3]),
            underline: _defineProperty({}, end.direction, spacing[5]),
            outline: _defineProperty({}, end.direction, spacing[5])
        }
    };
};
export var useStyle = function(param) {
    var _direction = param.direction, direction = _direction === void 0 ? 'left' : _direction, isRtl = param.isRtl, isSmallTextbox = param.isSmallTextbox, _variant = param.variant, variant = _variant === void 0 ? 'default' : _variant;
    var styles = useBuildStyleWithTheme(buildStyle);
    var oppositeDirection = direction === 'left' ? 'right' : 'left';
    var finalDirection = isRtl ? oppositeDirection : direction;
    return useMemo(function() {
        var ref, ref1;
        return {
            iconContainerStyle: _objectSpread({}, styles === null || styles === void 0 ? void 0 : styles['textbox-icon-container'], isSmallTextbox && (styles === null || styles === void 0 ? void 0 : styles['textbox-small']), styles === null || styles === void 0 ? void 0 : (ref = styles.variant) === null || ref === void 0 ? void 0 : ref[variant], styles === null || styles === void 0 ? void 0 : (ref1 = styles[finalDirection]) === null || ref1 === void 0 ? void 0 : ref1[variant])
        };
    }, [
        isSmallTextbox,
        styles,
        variant,
        finalDirection
    ]);
};
export default useStyle;
